<template>
  <div class="steps">
    <div
      class="steps-item"
      :class="index < (steps.index + 1) ? 'is-success' : ''"
      v-for="(item, index) in steps.step"
      :key="index"
    >
      <div class="steps-num">
        <div class="steps-num_box">
          <el-image :src="require('@/assets/images/step-finish.png')" v-if="index < (steps.index) || steps.index === steps.step.length - 1 "></el-image>
          <span v-else-if="index === (steps.index) && steps.index !== steps.step.length - 1" class="steps-current">{{index + 1}}</span>
          <span v-else>{{index + 1}}</span>
        </div>
      </div>
      <div class="mc-text-cneter mc-mt-15" :class="index < (steps.index) || steps.index === steps.step.length - 1 ? 'green-text' :  index === (steps.index) ? 'gray3-text' : 'gray9-text'">
        <p>{{item.text}}</p>
        <p class="mc-size12" v-if="item.time">{{item.time}}</p>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["steps"],
  data() {
    return {};
  },

  // components: {},

  // computed: {},

  // mounted: {},

  // methods: {}
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/less.less";
.steps {
  display: flex;
  .steps-item {
    flex: 1;
    text-align: center;
    .steps-num {
      height: 40px;
      text-align: center;
      position: relative;
      &:before {
        content: "";
        width: 50%;
        height: 2px;
        background: @ccc;
        position: absolute;
        left: 0;
        top: 21px;
      }
      &:after {
        content: "";
        width: 50%;
        height: 2px;
        background: @ccc;
        position: absolute;
        right: 0;
        top: 21px;
      }
      .steps-num_box {
        width: 40px;
        height: 40px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 1999;
        background: @white;
        border-radius: 50%;
      }
      span {
        display: inline-block;
        width: 40px;
        height: 40px;
        line-height: 40px;
        font-size: 24px;
        font-weight: bold;
        color: @white;
        background: @ccc;
        border-radius: 50%;
        &.steps-current{
          
        background: @green;
        }
      }
    }
    &.is-success {
      .steps-num {
        &:before {
          background: @green;
        }
        &:after {
          background: @green;
        }
      }
    }
    &:first-child {
      .steps-num:before {
        width: 0;
      }
      .steps-num:after {
        background: @green;
      }
    }
    &:last-child {
      .steps-num:after {
        width: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/steps.vue